export const API_ENDPOINTS = {
  baseUrl: import.meta.env.VITE_API_ENDPOINT,
  portal: import.meta.env.VITE_PORTAL_ENDPOINT
};